import React, { useState } from 'react';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';
import BgImage from '../Assets/Images/CareersBgImg.jpeg';
import { FaArrowRight } from 'react-icons/fa';

import ImpactImg from '../Assets/Images/Career1.jpg';
import DevelopmentImg from '../Assets/Images/Career2.jpg';
import SupportImg from '../Assets/Images/Career3.jpg';
import ProgressImg from '../Assets/Images/Career4.jpeg';
import InnovationImg from '../Assets/Images/Career5.jpg';
import CultureImg from '../Assets/Images/Career6.jpg';
import ClientsImg from '../Assets/Images/Career7.jpg';
import DiversityImg from '../Assets/Images/Career8.jpg'
import CareersFormSection from '../Components/CareersFormSection';

const Careers = () => {
  const [activeTab, setActiveTab] = useState('Impacts');

  const tabContent = {
    Impacts: {
      heading: 'Leading with Purpose',
      desc: 'We drive real-world impact through innovative software and digital transformation strategies tailored to each client. Our purpose is rooted in delivering meaningful change, fostering sustainable growth, and helping businesses navigate complexity with confidence.',
      image: ImpactImg,
    },
    Development: {
      heading: 'Grow with Confidence',
      desc: 'Continuous learning, tech skill enhancement, and challenging projects help our team grow every day. We foster an environment that encourages curiosity, supports certifications, and provides mentorship to ensure personal and professional development.',
      image: DevelopmentImg,
    },
    Support: {
      heading: 'Empowered by Support',
      desc: 'A collaborative environment where you are supported by your mentors, team leads, and leadership. From onboarding to advancement, we ensure you are never alone in your journey and have access to guidance, resources, and a strong peer network.',
      image: SupportImg,
    },
    Progress: {
      heading: 'Your Progress is Our Priority',
      desc: 'We invest in your future with clear career paths, promotions, and upskilling opportunities. Your ambitions are nurtured through personalized development plans, timely feedback, and recognition that ensures you keep moving forward.',
      image: ProgressImg,
    },
    Innovation: {
      heading: 'Driven by Innovation',
      desc: 'At Viveka Softek, innovation is in our DNA. We leverage the latest technologies to deliver intelligent, future-ready solutions. Our culture of experimentation encourages bold ideas, rapid prototyping, and staying ahead in a dynamic tech landscape.',
      image: InnovationImg,
    },
    Culture: {
      heading: 'A Culture That Cares',
      desc: 'We believe in a positive, inclusive, and empowering workplace culture that encourages creativity and work-life balance. From celebrating milestones to mental wellness programs, we put people at the center of everything we do.',
      image: CultureImg,
    },
    Clients: {
      heading: 'Client-Centric Excellence',
      desc: 'Our commitment to client success is unwavering. We align every solution with the client’s vision and goals to deliver lasting results. Through transparent collaboration, deep domain expertise, and a proactive mindset, we build partnerships that endure.',
      image: ClientsImg,
    }

  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="relative h-[80vh] flex items-center justify-center text-white bg-black overflow-hidden">
        <img
          src={BgImage}
          alt="Careers Background"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="relative z-10 px-4 w-full max-w-4xl">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-semibold tracking-widest text-left">CAREERS</h1>
            <div className="w-24 h-1 bg-[#00d9ff] mt-2"></div>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-6xl font-light mb-10">Build a future you believe in</p>
            <a href='#ApplyNow' className="inline-flex items-center gap-3 px-6 py-3 text-white font-semibold transition-all group cursor-pointer">
              Apply Now
              <span className="bg-white text-black p-2 rounded-full transform transition-transform duration-300 group-hover:rotate-90">
                <FaArrowRight />
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* Why VivekaSoftek Section */}
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-semibold mb-8 text-left">Why Vivekasoftek</h2>

          {/* Tabs */}
          <div className="w-full overflow-x-auto lg:pt-10">
            <div className="flex justify-start gap-20 mb-12 flex-nowrap whitespace-nowrap px-4">
              {Object.keys(tabContent).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`pb-2 text-lg font-medium border-b-2 transition-all ${activeTab === tab
                      ? 'border-[#00d9ff] text-[#00d9ff]'
                      : 'border-transparent text-white hover:text-[#00d9ff]'
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>



          {/* Tab Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            {/* Left: Image */}
            <div className='p-10'>
              <img
                src={tabContent[activeTab].image}
                alt={activeTab}
                className="rounded-lg w-full h-80 object-cover shadow-lg"
              />
            </div>

            {/* Right: Heading + Desc */}
            <div>
              <h3 className="text-2xl md:text-3xl font-medium mb-4">{tabContent[activeTab].heading}</h3>
              <p className="text-lg font-normal leading-relaxed text-justify">{tabContent[activeTab].desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Diversity Section */}
      <section className="relative h-[70vh] flex items-center bg-black text-white overflow-hidden">
        {/* Background Image with dark overlay */}
        <img
          src={DiversityImg}
          alt="Diversity Background"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-black opacity-5"></div>

        {/* Content */}
        <div className="relative z-10 max-w-5xl mx-auto px-6">
          <div className="border-l-4 border-[#00d9ff] pl-6">
            <h2 className="text-3xl md:text-5xl font-light mb-6">A belief in diversity</h2>
            <p className="text-lg md:text-2xl font-light leading-snug max-w-3xl">
              How do you create remarkable change? By hiring, celebrating and nurturing the best people—from all walks of life.
            </p>
          </div>

          {/* Button */}
          <div className="mt-8 text-right">
            <a
              href="/aboutUs"
              className="inline-flex items-center gap-2 text-white font-semibold transition-all group"
            >
              Learn more about us
              <span
                className="bg-white text-black p-2 rounded-full transform transition-transform duration-300 group-hover:translate-x-2"
              >
                <FaArrowRight />
              </span>
            </a>
          </div>
        </div>
      </section>

      <CareersFormSection />

      <Footer />
    </>
  );
};

export default Careers;
